import { type Metric, onCLS, onINP, onLCP, onTTFB } from "web-vitals";

import { recordEvent } from "@/services/telemetry";

/**
 * Reports Web Vitals (LCP, INP, CLS, TTFB) as `vitals`-category events — the standard proxies for
 * perceived experience. Metrics finalize as the page hides; the telemetry module's
 * visibility-change flush ships them before teardown.
 */
export function initializeWebVitals(): void {
  const report = (metric: Metric) => {
    recordEvent(
      `web_vitals.${metric.name.toLowerCase()}`,
      {
        vitals: {
          name: metric.name,
          value: metric.value,
          rating: metric.rating,
          navigationType: metric.navigationType,
        },
      },
      "vitals",
    );
  };
  onLCP(report);
  onINP(report);
  onCLS(report);
  onTTFB(report);
}
